@let tabsList = tabsSg();
@let selectedTab = selectedTabSg();
@let selectedIndex = selectedIndexSg();
@let disabled = disabledSg();

<div class="ds-slideout-tab">
  <div class="ds-slideout-tab__headers">
    @for (tab of tabsList; track $index) {
      <div
        class="ds-slideout-tab__header"
        [class.ds-slideout-tab__header--selected]="selectedTab === tab"
        (click)="
          !(disabled || tab.disabledSg()) &&
            selectedIndex !== $index &&
            onTabClickHandler($index)
        "
      >
        {{ tab.nameSg() }}
      </div>
    }
  </div>
  <div class="ds-slideout-tab__content">
    @if (selectedTab) {
      <ng-container
        *ngTemplateOutlet="selectedTab?.template ?? null"
      ></ng-container>
    }
  </div>
</div>
